import React from 'react';

const AdjectiveColor = () => {
  return (
    <div className="gadject-container">
      <p className="gadject-head">Adjectives of color:</p>

      <div className="gadject-stuff2">
        <div className="color-contain">
          <div className="color1"></div>
          <div className="color-text">dúdú (black)</div>
        </div>
        <div className="color-contain">
          <div className="color2"></div>
          <div className="color-text">funfun (white)</div>
        </div>
        <div className="color-contain">
          <div className="color3"></div>
          <div className="color-text">àwọ̀ ojú ọ̀run (blue)</div>
        </div>
        <div className="color-contain">
          <div className="color4"></div>
          <div className="color-text">pupa (red)</div>
        </div>

        <div className="color-contain">
          <div className="color5"></div>
          <div className="color-text">awọ pupa fẹẹrẹ (pink)</div>
        </div>
        <div className="color-contain">
          <div className="color6"></div>
          <div className="color-text">àwọ̀ ewé (green)</div>
        </div>
        <div className="color-contain">
          <div className="color7"></div>
          <div className="color-text">pupa rusurusu (yellow)</div>
        </div>
        <div className="color-contain">
          <div className="color8"></div>
          <div className="color-text">àwọ̀ igi (brown)</div>
        </div>
      </div>
    </div>
  );
};

export default AdjectiveColor;
